// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"453":"d855a71b","489":"40cd1aa1","693":"afd4f796","788":"136f37b7"}[chunkId] + ".chunk.js";
};